<template>
  <el-dialog
    title="菜单编辑"
    :visible.sync="state"
    width="60%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <!-- <tz-form
      width="110px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form> -->
    <el-form
      :model="formData"
      :rules="rules"
      label-width="110px"
      ref="formData"
    >
      <el-form-item label="名称" prop="title" required>
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item
        label="排序"
        prop="orders"
        required
        v-if="formData.isChild == true"
      >
        <el-input type="number" v-model="formData.orders"></el-input>
      </el-form-item>

      <div class="button-group" style="display: flex; justify-content: center">
        <el-button
          type="primary"
          style="width: 185px; margin: 0 20px"
          class="form-button"
          @click="submitFn"
        >
          <span>更新</span>
        </el-button>
      </div>
    </el-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
import { uploadFile } from '@/api/training'
// import MyEditor from './MyEditor.vue'
export default {
  // components: { MyEditor },
  props: {
    state: {
      type: Boolean,
      default: false
    },
    row: Object,
    roles: Array
  },
  watch: {
    // row(newData) {
    //   console.log("watch", newData);
    // },
    row: {
      handler(newData) {
        console.log(newData)
        if (!newData) return
        let that = this
        // console.log("watch", newData);
        that.formData = newData
        // that.$nextTick(() => {
        // that.$refs.editor.html = newData.content
        // })
      },
      immediate: true
    }
  },
  data() {
    return {
      fileList: [],
      formData: {
        // title: '',
        // content: '',
        // status: 1,
        // thumbnail: ''
      },
      // 表单配置
      formConfig: [
        {
          label: '讲解人',
          field: 'explainer',
          type: 'text'
          // rules: [{ required: true, message: '类型必填', trigger: 'blur' }]
        },
        {
          label: '备注',
          field: 'remark',
          type: 'text'
        }
      ],
      rules: {
        title: [{ required: true, message: '标题必填', trigger: 'blur' }],
        mpUrl: [
          { required: true, message: '推送公众号地址必填', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    uploadFn(parma) {
      console.log(parma.file)
      const formData = new FormData()
      formData.append('multipartFile', parma.file) // 传入bpmn文件
      this.$loading({
        text: '文件上传中'
      })
      uploadFile(formData).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          this.formData.uploadUrl = res.data.uploadUrl
          console.log(this.formData)
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          this.$loading().close()
        } else {
          this.$message({
            message: '上传失败',
            type: 'success'
          })
          this.$loading().close()
        }
      })
      // setTimeout(() => {
      //   this.$loading().close()
      // }, 1500)
    },
    //移除文件
    handleRemove() {
      this.formData.fileSize = ''
      this.formData.uploadName = ''
      this.formData.uploadType = ''
      this.formData.uploadUrl = ''
    },
    //超限制
    handleExceed(files, fileList) {
      console.log(files, fileList, this.fileList)

      this.$message.warning('目前只能上传一个包')
    },
    handleChange(file) {
      //获取上传文件大小
      console.log(file.size)
      let imgSize = Number(file.size / 1024 / 1024)
      console.log(imgSize)
      if (imgSize > 1000) {
        this.$msgbox({
          title: '',
          message: '文件大小不能超过1000MB，请重新上传。',
          type: 'warning'
        })
        this.fileList = []
        return
      }
    },
    // 判断富文本编辑器输入是否为空或回车
    getText(str) {
      return str
        .replace(/<[^<p>]+>/g, '') // 将所有<p>标签 replace ''
        .replace(/<[</p>$]+>/g, '') // 将所有</p>标签 replace ''
        .replace(/&nbsp;/gi, '') // 将所有 空格 replace ''
        .replace(/<[^<br/>]+>/g, '') // 将所有 换行符 replace ''
    },
    isNull(str) {
      if (str == '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    handleClose() {
      this.$emit('close')
    },
    submitFn() {
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          this.$emit('confirm', this.formData)
        }
      })
      console.log('更新数据处理', this.formData)
    }
    // submitFn() {

    //   this.$refs.formData.validate((isSuccess) => {
    //     if (isSuccess) {
    //       if (!this.formData.isChild) {

    //         let text = this.getText(this.formData.content)
    //         let validateValue = this.isNull(text)
    //         console.log(this.isNull(text)) // true表示判空  false表示不为空
    //         if (validateValue) {
    //           this.$message({
    //             message: '内容不能为空',
    //             type: 'error'
    //           })
    //           return
    //         }
    //       }

    //       // if (this.formData.thumbnail == '') {
    //       //   this.$message.error('至少上传一个附件！')
    //       //   return
    //       // }

    //       this.$emit('confirm', this.formData)
    //     }
    //   })
    //   console.log('更新数据处理', this.formData)
    // }
  },
  mounted() {
    // this.$nextTick(() => {
    // this.$refs.editor.html = this.formData.content
    // })
  }
}
</script>

<style></style>
